import { render, staticRenderFns } from "./bankerListView.vue?vue&type=template&id=3f52050b&scoped=true"
import script from "./bankerListView.vue?vue&type=script&lang=js"
export * from "./bankerListView.vue?vue&type=script&lang=js"
import style0 from "./bankerListView.vue?vue&type=style&index=0&id=3f52050b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f52050b",
  null
  
)

export default component.exports